import React from "react";
import StatusCard from "./StatusCard";
import StatsMiddle from "./StatsMiddle";
import StatsLower from "./StatsLower";

function StatsPopup() {
  return (
    <>
      <div
        className="w-full h-[30%] flex justify-between item-center"
        style={{ transformStyle: "preserve-3d" }}
      >
        <StatusCard />
      </div>
      <div
        className="h-[40%] w-full flex justify-between items-center"
        style={{ transformStyle: "preserve-3d" }}
      >
        <StatsMiddle />
      </div>
      <div
        className="h-[28%] w-full flex justify-between items-center"
        style={{ transformStyle: "preserve-3d" }}
      >
        <StatsLower />
      </div>
    </>
  );
}

export default StatsPopup;
